import { memo } from "react";

import { QuestionKidsPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/kids-policy";

import { usePlanKidsPolicy } from "./hooks/use-kids-policy/use-kids-policy";

export const QuestionDayTripPlanKidsPolicy = memo(() => {
	const {
		kidsPolicy,
		append,
		canRemoveKidsPolicyItem,
		removeKidsPolicyByIndex,
		getMinAge,
		kidsMaxAgeOptions,
		updateMaxAge,
		discountTypeOptions,
		updateDiscountType,
		ratioOptions,
		updateRatio,
		updateStaticPrice,
	} = usePlanKidsPolicy();

	const label = "プラン独自のキッズポリシー";
	const guide = "プラン独自のキッズポリシーが設定できます。<br/>このキッズポリシーは、プラン料金にのみ反映されます。";

	return (
		<QuestionKidsPolicy
			label={label}
			guide={guide}
			priceTypeLabel="プラン料金"
			appendKidsPolicyItem={append}
			kidsPolicy={kidsPolicy?.value ?? undefined}
			isEdited={kidsPolicy?.isEdited}
			hasError={kidsPolicy?.hasError}
			questionKidsPolicyItemProps={{
				canRemoveKidsPolicyItem,
				kidsPolicyKidsMaxAgeMinAge: getMinAge,
				kidsPolicyKidsMaxAgeOptions: kidsMaxAgeOptions,
				changeKidsPolicyMaxAge: updateMaxAge,
				discountTypeOptions,
				changeKidsPolicyDiscountType: updateDiscountType,
				kidsPolicyRatioOptions: ratioOptions,
				changeKidsPolicyRatio: updateRatio,
				changeKidsPolicyStaticPrice: updateStaticPrice,
				removeKidsPolicyItemByIndex: removeKidsPolicyByIndex,
			}}
		/>
	);
});

QuestionDayTripPlanKidsPolicy.displayName = "QuestionDayTripPlanKidsPolicy";
